import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private _http: HttpClient) {}

  submitSessionData(): void {
    const viewedProperties = JSON.parse(sessionStorage.getItem('viewedProperties') || '[]');

    if (viewedProperties.length > 0) {
      this.insertPropertyPerformance(viewedProperties).subscribe(
        response => {
          sessionStorage.removeItem('viewedProperties'); // Reset session storage
        },
        error => {
          console.error('Error submitting session data:', error);
        }
      );
    }
  }

  insertPropertyPerformance(viewedProperties: any[]): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this._http.post(environment.apiUrl + 'api/postrequest/insertpropertyperformance', viewedProperties, httpOptions).pipe(
      tap(response => {
      }),
      retry(2),
      catchError(this.handleError)
    );
  }

  private handleError(error: any): Observable<never> {
    return throwError(error);
  }
}
